<template>
  <v-dialog v-model="visible" persistent max-width="600px">
    <v-card>
      <v-card-title class="headline">Checkout</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item v-for="item in cart" :key="item.id">
            <v-list-item-avatar>
              <v-img :src="item.image" height="100px"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle>${{ item.price.toFixed(2) }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <div class="cart-summary">
          <p>Total Items: {{ cart.length }}</p>
          <p>Subtotal: ${{ subtotal.toFixed(2) }}</p>
          <p>Taxes (8%): ${{ taxAmount.toFixed(2) }}</p>
          <p>Grand Total: ${{ grandTotal.toFixed(2) }}</p>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="green darken-1" text @click="submitOrder">Place Order</v-btn>
        <v-btn color="red darken-1" text @click="$emit('close')">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    cart: Array,
    subtotal: Number,
    taxAmount: Number,
    grandTotal: Number
  },
  methods: {
    submitOrder() {
      // Implement the submit logic here
      this.$emit('order-submitted');
    }
  }
};
</script>
